<template>
  <div style="height: 100%">
    <InitialLoading v-if="loading" />

    <div style="height: calc(100% - 4.5rem); position: relative" v-else>
      <!-- System notice -->
      <SystemNotice />

      <!-- Chat container -->
      <ChatContainer />

      <!-- Input -->
      <InputBar />
    </div>
  </div>
</template>

<script setup>
// Import components
import InitialLoading from './InitialLoading'
import SystemNotice from '../Interface/General/SystemNotice'
import ChatContainer from './ChatContainer'
import InputBar from './InputBar'

// Import modules
import { computed, onBeforeMount, onMounted } from 'vue'
import { useStore } from 'vuex'

// Init modules∂
const store = useStore()

// Computed
const loading = computed(() => {
  return store.state.chat.loading
})

const socket = computed(() => {
  return store.state.socket
})

// Methods
const disconnectionDetector = () => {
  const interval = setInterval(() => {
    if (socket.value.socket_server?.disconnected) {
      clearInterval(interval)
      console.log('Disconnected from socket server')
      store.commit('SET_CHAT_LOADING', true)
      serverRestartDetector()
    }
  }, 1000)
}
const serverRestartDetector = () => {
  const interval = setInterval(() => {
    console.log('Waiting for socket server restart...')
    if (socket.value.socket_server?.connected) {
      clearInterval(interval)
      disconnectionDetector()
    }
  }, 1000)
}

// Mounted
onMounted(() => {
  disconnectionDetector()
})
// Created
onBeforeMount(() => {
  store.dispatch('updateSocketServer')
})
</script>
